
/**
 * 运行环境
 * prod: 生产环境正式线
 * test: 生产环境测试线
 * dev: 开发环境
 */
 export const VUE_APP_MODE = process.env.VUE_APP_MODE;

 /**
  * 透传接口域名
  */
 export const CROS_API = VUE_APP_MODE === 'test'
   ? 'http://jxb.t.huijiaoyun.com/msscy/agency/route' : 'https://msscy.huijiaoyun.com/msscy/agency/route'//'http://jxb.t.huijiaoyun.com/msscy/agency/route';
 
 /**
  * 平台天喻云统一网关
  */
 export const PLATFORM_OPEN_API = VUE_APP_MODE === 'test'
   ? 'http://opengate-test.t.huijiaoyun.com' : 'https://gateway.tianyuyun.com';

 
 /**
  * msscy接口配置
  */

  export const MSSCY_API = VUE_APP_MODE === 'test'
  ? 'http://msscy.t.huijiaoyun.com' : 'https://msscy.huijiaoyun.com';
 
 /**
  * 平台网关访问appId
  */
 export const PLATFORM_OPEN_APP_ID = VUE_APP_MODE === 'test'
   ? '5txk2cf684cj6x7b28r6darkt38tr4jw' : '5txk2cf684cj6x7b28r6darkt38tr4jw';